module.exports = __webpack_public_path__ + "img/news8-1.4791f4af.png";